<template>
  <div class="join-us-background">
    <div class="join-us-banner">
      <div class="join-us-container">
        <div class="join-us-banner-title">性能测试 / {{testDocumentContent.title}}</div>
      </div>

      <img class="join-us-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="join-us-container">

     <div class="join-us-content">
       <div class="join-us-content-title">
         <div class="join-us-content-title-text">{{testDocumentContent.title}}</div>
       </div>
       <div class="join-us-content-info">
         <div class="join-us-content-info-text" v-html="testDocumentContent.content"></div>
       </div>



     </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    name: "companyIntroduce",
    computed: {
      ...mapState({
        testDocumentContent: state => state.TestDocument.testDocumentContent.info,
      })
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      "$route": "getTestDocumentContent"
    },
    created(){
      this.$store.dispatch('getTestDocumentContent',this.$route.params.id).then(res => {
      })
    },
    methods:{
      getTestDocumentContent(){
        this.$store.dispatch('getTestDocumentContent',this.$route.params.id).then(res => {
        })
      }

    }

  }
</script>

<style scoped>

  .join-us-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .join-us-background{
    margin-top: 70px;
  }
  .join-us-banner{
    overflow:hidden;
  }
  .join-us-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .join-us-banner-img{
    min-width:100%;
    height:165px;
  }
  .join-us-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .join-us-content-title{
    padding-top: 50px;
    text-align: center;
  }
  .join-us-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .join-us-content-info{
    margin-top: 50px;
  }
  .join-us-content-info-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
  }
  .join-us-position{
    padding-top: 18px;
  }
  .join-us-position-name{
    color:rgba(73,145,201,1);
    font-size:22px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    line-height:50px;
  }
  .join-us-position-title{
    font-size:18px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    line-height:50px;
  }
  .join-us-position-require-text{
    font-size:16px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:25px;
    margin-bottom: 8px;
  }
  .fa-join-us-position{
    margin-right: 8px;
  }
  @media screen and (max-width:482px) {
    .join-us-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .join-us-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .join-us-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .join-us-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .join-us-container{
      max-width: 1068px;
    }
  }

</style>